module.exports = __webpack_public_path__ + "static/media/Gallery-17.db76d843.jpg";